import {
  CHANGE_CURRENCY_STATUS_START,
  CHANGE_CURRENCY_STATUS_SUCCESS,
  CHANGE_CURRENCY_STATUS_ERROR,
  SET_BASE_CURRENCY_START,
  SET_BASE_CURRENCY_SUCCESS,
  SET_BASE_CURRENCY_ERROR,
  CURRENCY_RATES_FETCH_SUCCESS,
  SET_PAYOUT_CURRENCY_START,
  SET_PAYOUT_CURRENCY_SUCCESS,
  SET_PAYOUT_CURRENCY_ERROR,
} from '../../../constants';
import showToaster from '../../../helpers/showToaster';
import {
  setBaseCurrencyMutation,
  updateCurrencyMutation,
  getCurrencyRatesQuery,
  getBaseCurrencyQuery,
  getCurrencyQuery,
  updatePayoutCurrencyMutation,
} from '../../../lib/graphql';

export function updateCurrencyStatus(
  id,
  isEnable,
  symbol,
  currentPage,
  searchList,
) {
  return async (dispatch, getState, { client }) => {
    dispatch({
      type: CHANGE_CURRENCY_STATUS_START,
    });

    try {
      let baseCurrencyId;
      const { data } = await client.query({
        query: getBaseCurrencyQuery,
        fetchPolicy: 'network-only',
      });
      if (data && data?.getBaseCurrency) {
        baseCurrencyId = data?.getBaseCurrency?.id;
      }

      // Warn admin if he/she try to disable the base currency
      if (baseCurrencyId === id) {
        showToaster({ messageId: 'baseCurrencyError', toasterType: 'error' });
      } else {
        const { data } = await client.mutate({
          mutation: updateCurrencyMutation,
          variables: { id, isEnable, symbol },
        });

        if (data?.updateCurrency?.status === 200) {
          dispatch({ type: CHANGE_CURRENCY_STATUS_SUCCESS });
          showToaster({
            messageId: 'updateCurrencyStatus',
            toasterType: 'success',
          });
        } else {
          dispatch({ type: CHANGE_CURRENCY_STATUS_ERROR });
          showToaster({
            messageId: 'commonError',
            toasterType: 'error',
            requestContent: data?.updateCurrency?.errorMessage,
          });
          return false;
        }
      }
    } catch (error) {
      dispatch({
        type: CHANGE_CURRENCY_STATUS_ERROR,
        payload: {
          error,
        },
      });
      showToaster({ messageId: 'updateCurrencyError', toasterType: 'error' });
      return false;
    }
    return true;
  };
}

export function setBaseCurrency(id, currentPage, searchList) {
  return async (dispatch, getState, { client }) => {
    dispatch({
      type: SET_BASE_CURRENCY_START,
    });

    try {
      const { data } = await client.mutate({
        mutation: setBaseCurrencyMutation,
        variables: { id },
        refetchQueries: [
          { query: getCurrencyQuery, variables: { currentPage, searchList } },
        ],
      });

      if (data.setBaseCurrency.status == 200) {
        dispatch({
          type: SET_BASE_CURRENCY_SUCCESS,
        });

        const currency = await client.query({
          query: getCurrencyRatesQuery,
          fetchPolicy: 'network-only',
        });

        if (currency && currency?.data && currency?.data?.getCurrencyRates) {
          let currencyRates;
          const base = currency?.data?.getCurrencyRates?.base;
          if (currency?.data?.getCurrencyRates?.rates != null) {
            currencyRates = JSON.parse(currency?.data?.getCurrencyRates?.rates);
          }

          showToaster({ messageId: 'setBaseCurrency', toasterType: 'success' });
          dispatch({
            type: CURRENCY_RATES_FETCH_SUCCESS,
            payload: {
              base,
              to: '',
              rates: currencyRates,
            },
          });
        }
      }
    } catch (error) {
      dispatch({
        type: SET_BASE_CURRENCY_ERROR,
        payload: {
          error,
        },
      });
      showToaster({ messageId: 'baseCurrencyFailed', toasterType: 'error' });
      return false;
    }
    return true;
  };
}

export const updatePayoutCurrency = ({
  id,
  isPayoutCurrency,
  symbol,
}) => async (dispatch, getState, { client }) => {
  dispatch({ type: SET_PAYOUT_CURRENCY_START });
  try {
    const { data } = await client.mutate({
      mutation: updatePayoutCurrencyMutation,
      variables: { id, isPayoutCurrency, symbol },
    });

    if (data?.updatePayoutCurrency?.status === 200) {
      dispatch({ type: SET_PAYOUT_CURRENCY_SUCCESS });
      showToaster({
        messageId: 'payoutCurrencySuccess',
        toasterType: 'success',
      });
    } else {
      showToaster({
        messageId: 'commonError',
        requestContent: data?.updatePayoutCurrency?.errorMessage,
        toasterType: 'error',
      });
    }
  } catch (error) {
    dispatch({
      type: SET_PAYOUT_CURRENCY_ERROR,
      payload: { error },
    });
    showToaster({ messageId: 'payoutCurrencyFailed', toasterType: 'error' });
    return false;
  }
  return true;
};
